import PerformanceAppearanceList from "../components/PerformanceAppearanceList";

const ListPerformanceAppearancePage = () => {
  return (
    <PerformanceAppearanceList />
  );
};

export default ListPerformanceAppearancePage;
